import type { ComponentType } from 'react';

import type { PermissionCode } from '@/auth/types';
import { accountScreens } from '@/features/accounts/screens';
import { adminExtraRoutes, adminScreens } from '@/features/admin/screens';
import { dashboardScreens } from '@/features/dashboard/screens';
import { offerScreens } from '@/features/offers/screens';
import { organizationExtraRoutes, organizationScreens } from '@/features/organization/screens';
import { profileScreens } from '@/features/profile/screens';
import { ratesScreens } from '@/features/rates/screens';
import { reportScreens } from '@/features/reports/screens';
import { taskExtraRoutes, taskScreens } from '@/features/tasks/screens';

/**
 * EKRAN KAYDI — menu kimligi -> bilesen.
 *
 * Rotalar `menus.ts`'ten uretiliyor (router.tsx). Bir menu ogesinin gercek ekrani
 * burada kayitliysa o cizilir; degilse `PlaceholderPage`. Boylece bir feature'i
 * hayata gecirmek router.tsx'e DOKUNMADAN mumkun: feature kendi klasorunde bir
 * `screens.ts` disa aktarir, tek satirla buraya baglanir.
 *
 * Neden ayri bir dosya: router.tsx yalniz KOMPOZISYON ve guard zinciriyle ilgilenir.
 * Her yeni ekranin o dosyayi degistirmesi, birbirinden bagimsiz feature'lari tek bir
 * dosyada catistiran bir darboga uretirdi.
 *
 * Detay rotalari (`/talepler/:taskId` gibi) menude YER ALMAZ; onlar EXTRA_ROUTES'ta.
 */
export type ScreenMap = Readonly<Record<string, ComponentType>>;

export const SCREENS: ScreenMap = Object.freeze({
  ...ratesScreens,
  ...taskScreens,
  ...offerScreens,
  ...accountScreens,
  ...organizationScreens,
  ...profileScreens,
  ...dashboardScreens,
  ...reportScreens,
  ...adminScreens,
});

/**
 * Menude gorunmeyen, bolgeye ait ek rotalar. `to` bolge tabanina GORE degil, tam
 * yol olarak yazilir; guard zincirini bolge grubundan miras alirlar.
 */
export type ExtraRoute = Readonly<{
  path: string;
  component: ComponentType;
  /** Buro yetkisi gerektiriyorsa kodu; yoksa bolge guard'i yeterli. */
  permission?: PermissionCode;
  adminOnly?: boolean;
}>;

export const EXTRA_ROUTES: Readonly<Record<string, readonly ExtraRoute[]>> = Object.freeze({
  customer: Object.freeze([...(taskExtraRoutes.customer ?? [])]),
  exchange: Object.freeze([
    ...(taskExtraRoutes.exchange ?? []),
    ...(organizationExtraRoutes.exchange ?? []),
  ]),
  admin: Object.freeze([...(adminExtraRoutes.admin ?? [])]),
});
